//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PosPendingSalesExecuteView from "@/views/POS/PosPendingSales/execute"

//
export default {
  path: "pending_pos_sales",
  component: ModuleLayout,
  children: [
    {
      name: "pos-pending-sales",
      path: "",
      component: PosPendingSalesExecuteView,
    },
  ],
  meta: {
    title: "Anulación de Ticket de Ventas"
  },
}